import styled from "styled-components";
import { shade } from "polished";
import { Modal } from "antd";

export const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 16px;
    overflow: hidden;
  }
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
`;

export const CheckIconContainer = styled.div`
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background-color: #d4f4dd;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;

  svg {
    width: 40px;
    height: 40px;
    color: #52c41a;
  }
`;

export const Title = styled.h2`
  font-size: 30px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 30px;
  text-align: center;
`;

export const CollaboratorInfoContainer = styled.div`
  background-color: #f7f8fa;
  border-radius: 8px;
  padding: 24px;
  width: 100%;
  margin-bottom: 24px;
`;

export const CollaboratorName = styled.h3`
  font-size: 20px;
  font-weight: 600;
  color: #1a1a1a;
  text-align: center;
  margin-bottom: 20px;
`;

export const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const InfoLabel = styled.span`
  font-size: 14px;
  color: #666666;
  font-weight: 400;
`;

export const InfoValue = styled.span`
  font-size: 14px;
  color: #1a1a1a;
  font-weight: 500;
  text-align: right;
`;

export const PrintQuestionContainer = styled.div`
  background-color: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 8px;
  padding: 16px;
  width: 100%;
  margin-bottom: 24px;
  text-align: center;
`;

export const PrintQuestion = styled.p`
  font-size: 14px;
  color: #002244;
  font-weight: 500;
  margin: 0;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding-top: 16px;
`;

export const ButtonPrintLater = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  color: #666666;
  background-color: transparent;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s;
  width: 100%;

  &:hover:not(:disabled) {
    color: #068ec3;
    border-color: #068ec3;
    transform: scale(1.05);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const ButtonPrintNow = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
  background-color: #068ec3;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s;
  width: 100%;
  min-height: 40px;

  &:hover:not(:disabled) {
    background-color: ${shade(0.2, "#068ec3")};
    transform: scale(1.05);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  svg {
    width: 16px;
    height: 16px;
  }

  /* Customizar cor do Spin do AntD para branco */
  .ant-spin-dot-item {
    background-color: #ffffff;
  }
`;
